import { Injectable, Type } from '@angular/core';
import { AutomationTrigger } from '@kinet-open-network/shared/data-access/model';
import { TRIGGERS_MAP } from './triggers';
import { TriggerComponent } from './triggers/abstract-trigger.component';

@Injectable()
export class AutomationTriggerService {
  getComponentForType<T extends AutomationTrigger>(
    type?: T,
  ): Type<TriggerComponent<T>> {
    if (!type) {
      return TriggerComponent as Type<TriggerComponent<T>>;
    }
    return (TRIGGERS_MAP[type] || TriggerComponent) as Type<TriggerComponent<T>>;
  }
}
